/* eslint-disable global-require */
module.exports = {
  vpFilters: require('./src/filters'),
  vpConstants: require('./src/constants'),
  vpLog: require('./src/log'),
  vpLocalization: require('./src/localization-formatting'),
};
